import { atom } from "recoil";
import { SortationStateKey } from "./SortationStateKeys";

export const sortationIdState = atom<string | undefined>({
  key: SortationStateKey.SORTATION_ID,
  default: undefined,
});
